

import React from 'react';
import './Authentication.scss';  
import partner from "../../Assets//80.png";
import logo from "../../Assets/image (63).png";
import sidelogo from "../../Assets/image (64).png";
import circle1 from "../../Assets/image (62).png";
import circle2 from "../../Assets/image (61).png";
import { Outlet } from "react-router-dom";
  
  export default function Authentication() {
    return (
    <div className="login-main">

 <div className="login-dark-overlay"></div>

   <img className='logooo' src={logo} alt="logo" width={200} />

 <div className="login-side-logo">
   <img src={sidelogo} alt="" width={300} />
 </div>
<div>
<div className='circlee'>
  <img src={circle1} alt="" width={440} />
</div>

<div className='circlee2'>
  <img src={circle1} alt="" width={440} />
</div>
</div>


<div>
<div className='blue-circlee'>
  <img src={circle2} alt="" width={300} />
</div>



</div>

<div className='blue-circleeee'>
  <img src={circle2} alt=""  width={330} />
</div>
<div > 
<div className="login-light-overlay">
<img  className="rr" src={partner} alt="" />
<Outlet />
</div>
</div>

 </div>
 
    )
  }
  

